@if (isOverlayVisible() | async) {
  <lib-overlay [zIndexOverride]="110" [attr.data-qa-id]="'overlay'"></lib-overlay>
}

<div class="main" [class.main--no-nav-bar]="hideNavBar" [ngStyle]="{ 'padding-top': headerHeight() }" #top>
  @if (!(loadingInitial$ | async) && (isAuthenticated$ | async)) {
    <aff-cookie-consent-panel
      [cookieName]="cookieConsentName"
      (cookieConsentChanged)="setClickedCookieConsent($event)"
    ></aff-cookie-consent-panel>
  }
  <div class="main__content px-sm pb-sm">
    <router-outlet (activate)="scrollToTop()"></router-outlet>
    @if (loadingInitial$ | async; as loading) {
      <div [attr.data-qa-id]="'lib-spinner'" class="pt-md">
        <lib-spinner [imageUrl]="$safeNavigationMigration(loading?.imageUrl)">
          <h4>{{ loading?.infoText }}</h4>
        </lib-spinner>
      </div>
    }
    @if ((error$ | async) && !(loadingInitial$ | async)) {
      <aff-error-message
        [error]="error$ | async"
        (retry)="navigateTo()"
        [attr.data-qa-id]="'error-message'"
      ></aff-error-message>
    }
  </div>
</div>

<div class="button-cont flex">
  <!-- Scroll to top floating button -->
  @if (isScrollToTopIconVisible) {
    <lib-chevron-icon
      [@inOutAnimation]
      class="icon-theme icon-xxs p-sm c-pointer mr-xxs"
      (click)="scrollToTop(top)"
    ></lib-chevron-icon>
  }

  @if (showFaq) {
    <lib-faq-icon
      style="padding: 9px"
      class="icon-theme icon-md c-pointer"
      (click)="isFaqModalVisible = true"
      [attr.data-qa-id]="'faq-button'"
    ></lib-faq-icon>
  }
</div>

@if (isFaqModalVisible) {
  <lib-modal
    [attr.data-qa-id]="'faq-modal'"
    (closeModalEvent)="isFaqModalVisible = false"
    [alignToTop]="true"
  >
    <ng-template #content>
      <section class="faq-header py-xs color-off-white">
        <h3 class="text-align-center">Frequently asked questions</h3>
        <div class="p-xs design-refresh">
          @for (item of faqList; track item; let i = $index) {
            <lib-accordion-item
              [uniqueSetId]="'user-auth-faqs'"
              [idToScroll]="'_faq' + i"
              [bespokeScrollContainer]="'.modal-container'"
              [isLegacy]="false"
            >
              <p class="color-grey" title>{{ item.title }}</p>
              <div body class="small font-weight-regular color-black" [innerHTML]="item.body"></div>
            </lib-accordion-item>
          }
        </div>
      </section>
    </ng-template>
  </lib-modal>
}

<!-- Notifications -->
<p-toast position="top-right" styleClass="custom-toast">
  <ng-template #message let-message>
    <div class="notification-container flex py-xxs" [attr.data-qa-id]="'notification'">
      @if (message.severity === 'success') {
        <lib-tick-icon [attr.data-qa-id]="'green-icon'" class="green-icon icon-xs px-sm py-xxxs"></lib-tick-icon>
      } @else {
        <lib-close-icon [attr.data-qa-id]="'red-icon'" class="icon-red icon-xxs px-sm py-xxs"></lib-close-icon>
      }

      <div class="text-align-left">
        <h4 class="toast-title">{{ message.summary }}</h4>
        <p>
          {{ message.detail }}
          @if (message.severity === 'success') {
            <a [routerLink]="[message.data]">Go to accounts list</a>
          } @else {
            Please <a [routerLink]="[message.data]">go to accounts list</a> to try again.
          }
        </p>
      </div>
    </div>
  </ng-template>
</p-toast>
